module.exports = "/img/partnership-1.8c24ea8f.png";